import { Component, OnInit } from '@angular/core';

import { Router } from '@angular/router';
import { DataTableEvent } from '../../components/data-table/data-table.component';
import { AngieCustomersService } from '@services/angie-customers/angie-customers.service';

@Component({
    selector: 'app-angie-customer',
    templateUrl: './angie-customer.component.html',
    styleUrls: ['./angie-customer.component.scss'],
    providers: [AngieCustomersService],
    standalone: false
})
export class AngieCustomerComponent implements OnInit {

  public title = 'Angie Customers';

  public columns = [{ prop: 'company' }];

  constructor(public angieCustomersService: AngieCustomersService, private router: Router) {
  }

  ngOnInit() {
  }

  public onDetail(event: DataTableEvent): void {
    this.router.navigate(['angie-customers', event.row._id]);
  }
}
